
import React from 'react'

export function Upload(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M5 10h4v6h6v-6h4l-7-7l-7 7zm0 8v2h14v-2H5z"/></svg>
  )
}
export default Upload

